function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.math.log2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { transform } from "ol/proj";
import { canvBase, MERC_CROSSMATRIX, MERC_MAX } from "../const_ex";
import { addIdToPoi, normalizeLayer, normalizeLayers, normalizePoi } from "../normalize_pois";
import { normalizeArg } from "../functions";
import { polygon } from "@turf/helpers";
import centroid from "@turf/centroid";
import { booleanPointInPolygon, lineIntersect, lineString } from "@turf/turf";
export function setCustomFunction(Base) {
  var Mixin = /*#__PURE__*/function (_Base) {
    _inherits(Mixin, _Base);
    var _super = _createSuper(Mixin);
    function Mixin() {
      var _this;
      _classCallCheck(this, Mixin);
      _this = _super.apply(this, arguments);
      _this.officialTitle = "";
      _this.title = "";
      _this.mapID = "";
      _this.label = "";
      _this.homeMarginPixels = 0;
      _this.mercatorXShift = 0;
      _this.mercatorYShift = 0;
      return _this;
    }
    _createClass(Mixin, [{
      key: "initialize",
      value: function initialize(options) {
        var _this2 = this;
        var _a;
        options = normalizeArg(options);
        this.mapID = options.mapID;
        this.homePosition = options.homePosition;
        this.mercZoom = options.mercZoom;
        this.label = options.label;
        this.maxZoom = options.maxZoom;
        this.minZoom = options.minZoom;
        this.poiTemplate = options.poiTemplate;
        this.poiStyle = options.poiStyle;
        this.iconTemplate = options.iconTemplate;
        this.icon = options.icon;
        this.selectedIcon = options.selectedIcon;
        this.mercatorXShift = options.mercatorXShift;
        this.mercatorYShift = options.mercatorYShift;
        this.weiwudi = options.weiwudi;
        if (options.envelopeLngLats) {
          var lngLats = options.envelopeLngLats;
          var mercs = lngLats.map(function (lnglat) {
            return transform(lnglat, "EPSG:4326", "EPSG:3857");
          });
          mercs.push(mercs[0]);
          this.envelope = polygon([mercs]);
          this.centroid = (_a = centroid(this.envelope).geometry) === null || _a === void 0 ? void 0 : _a.coordinates;
        }
        for (var i = 0; i < META_KEYS.length; i++) {
          var key = META_KEYS[i];
          var option_key = META_KEYS_OPTION[i];
          this.set(key, options[option_key] || options[key]);
        }
        var thumbWait = options.thumbnail ? new Promise(function (resolve) {
          _this2.thumbnail = options.thumbnail;
          resolve(undefined);
        }) : new Promise(function (resolve) {
          _this2.thumbnail = "./tmbs/".concat(options.mapID, ".jpg");
          fetch(_this2.thumbnail).then(function (response) {
            if (response.ok) {
              resolve(undefined);
            } else {
              _this2.thumbnail = "./tmbs/".concat(options.mapID, "_menu.jpg");
              resolve(undefined);
            }
          }).catch(function (_error) {
            _this2.thumbnail = "./tmbs/".concat(options.mapID, "_menu.jpg");
            resolve(undefined);
          });
        }).catch(function (_error) {
          _this2.thumbnail = "./tmbs/".concat(options.mapID || options.sourceID, "_menu.jpg");
        });
        var poisWait = this.resolvePois(options.pois);
        this.initialWait = Promise.all([poisWait, thumbWait]);
        setupTileLoadFunction(this);
      }
    }, {
      key: "isBasemap",
      value: function isBasemap() {
        return this.constructor.isBasemap();
      }
    }, {
      key: "isWmts",
      value: function isWmts() {
        return this.constructor.isWmts();
      }
    }, {
      key: "isMapbox",
      value: function isMapbox() {
        return this.constructor.isMapbox();
      }
    }, {
      key: "getCacheEnable",
      value: function getCacheEnable() {
        return !!this.weiwudi;
      }
    }, {
      key: "getTileCacheStatsAsync",
      value: function () {
        var _getTileCacheStatsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (this.weiwudi) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", {});
              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.weiwudi.stats();
              case 5:
                return _context.abrupt("return", _context.sent);
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", {});
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[2, 8]]);
        }));
        function getTileCacheStatsAsync() {
          return _getTileCacheStatsAsync.apply(this, arguments);
        }
        return getTileCacheStatsAsync;
      }()
    }, {
      key: "getTileCacheSizeAsync",
      value: function () {
        var _getTileCacheSizeAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var stats;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getTileCacheStatsAsync();
              case 2:
                stats = _context2.sent;
                return _context2.abrupt("return", stats.size || 0);
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function getTileCacheSizeAsync() {
          return _getTileCacheSizeAsync.apply(this, arguments);
        }
        return getTileCacheSizeAsync;
      }()
    }, {
      key: "fetchAllTileCacheAsync",
      value: function () {
        var _fetchAllTileCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(callback) {
          var _this3 = this;
          var listner, deleteListner;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (this.weiwudi) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _context3.prev = 2;
                listner = function listner(e) {
                  callback(e.type, e.detail);
                };
                deleteListner = function deleteListner(e) {
                  _this3.weiwudi.removeEventListener("proceed", listner);
                  _this3.weiwudi.removeEventListener("finish", deleteListner);
                  _this3.weiwudi.removeEventListener("stop", deleteListner);
                  _this3.weiwudi.removeEventListener("canceled", deleteListner);
                  listner(e);
                };
                this.weiwudi.addEventListener("proceed", listner);
                this.weiwudi.addEventListener("finish", deleteListner);
                this.weiwudi.addEventListener("stop", deleteListner);
                this.weiwudi.addEventListener("canceled", deleteListner);
                _context3.next = 11;
                return this.weiwudi.fetchAll();
              case 11:
                _context3.next = 15;
                break;
              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](2);
              case 15:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this, [[2, 13]]);
        }));
        function fetchAllTileCacheAsync(_x) {
          return _fetchAllTileCacheAsync.apply(this, arguments);
        }
        return fetchAllTileCacheAsync;
      }()
    }, {
      key: "cancelTileCacheAsync",
      value: function () {
        var _cancelTileCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (this.weiwudi) {
                  _context4.next = 2;
                  break;
                }
                return _context4.abrupt("return");
              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return this.weiwudi.cancel();
              case 5:
                _context4.next = 9;
                break;
              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](2);
              case 9:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this, [[2, 7]]);
        }));
        function cancelTileCacheAsync() {
          return _cancelTileCacheAsync.apply(this, arguments);
        }
        return cancelTileCacheAsync;
      }()
    }, {
      key: "clearTileCacheAsync",
      value: function () {
        var _clearTileCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (this.weiwudi) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                _context5.prev = 2;
                _context5.next = 5;
                return this.weiwudi.clean();
              case 5:
                _context5.next = 9;
                break;
              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](2);
              case 9:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this, [[2, 7]]);
        }));
        function clearTileCacheAsync() {
          return _clearTileCacheAsync.apply(this, arguments);
        }
        return clearTileCacheAsync;
      }()
    }, {
      key: "getMap",
      value: function getMap() {
        return this._map;
      }
    }, {
      key: "setMap",
      value: function setMap(map) {
        this._map = map;
      }
    }, {
      key: "setViewpointRadian",
      value: function setViewpointRadian(cond) {
        var _this4 = this;
        var merc;
        var xy;
        var mercZoom = cond.mercZoom;
        var zoom = cond.zoom;
        var direction = cond.direction;
        var rotation = cond.rotation;
        var map = this.getMap();
        var view = map === null || map === void 0 ? void 0 : map.getView();
        if (cond.latitude !== undefined && cond.longitude !== undefined) {
          merc = transform([cond.longitude, cond.latitude], "EPSG:4326", "EPSG:3857");
        }
        if (cond.x !== undefined && cond.y != undefined) {
          xy = [cond.x, cond.y];
        }
        this.viewpoint2MercsAsync().then(function (mercs) {
          return _this4.mercs2MercViewpoint(mercs);
        }).then(function (mercViewpoint) {
          var mercs = _this4.mercViewpoint2Mercs([merc || mercViewpoint[0], mercZoom || mercViewpoint[1] || 17, direction !== null ? direction : mercViewpoint[2]]);
          _this4.mercs2ViewpointAsync(mercs).then(function (viewpoint) {
            if (merc != null) {
              view === null || view === void 0 ? void 0 : view.setCenter(viewpoint[0]);
            } else if (xy != null) {
              view === null || view === void 0 ? void 0 : view.setCenter(xy);
            }
            if (mercZoom != null) {
              view === null || view === void 0 ? void 0 : view.setZoom(viewpoint[1]);
            } else if (zoom != null) {
              view === null || view === void 0 ? void 0 : view.setZoom(zoom);
            }
            if (direction != null) {
              view === null || view === void 0 ? void 0 : view.setRotation(viewpoint[2]);
            } else if (rotation != null) {
              view === null || view === void 0 ? void 0 : view.setRotation(rotation);
            }
          });
        });
      }
    }, {
      key: "setViewpoint",
      value: function setViewpoint(cond) {
        if (cond.rotation) {
          cond.rotation = cond.rotation * Math.PI / 180;
        }
        if (cond.direction) {
          cond.direction = cond.direction * Math.PI / 180;
        }
        this.setViewpointRadian(cond);
      }
    }, {
      key: "goHome",
      value: function goHome() {
        var ratio = 1;
        var map = this.getMap();
        var div = map.getTarget();
        if (typeof div === "string") {
          div = document.getElementById(div);
        }
        var homeMarginPixels = map.homeMarginPixels;
        var screenSize = [(div.clientWidth - homeMarginPixels - 10) * ratio, (div.clientHeight - homeMarginPixels - 10) * ratio];
        var options = {
          longitude: this.homePosition[0],
          latitude: this.homePosition[1],
          zoom: this.defZoom(screenSize)
        };
        if (this.getMap().northUp) options.direction = 0;else options.rotation = 0;
        this.setViewpointRadian(options);
      }
    }, {
      key: "resetRotation",
      value: function resetRotation() {
        this.setViewpointRadian({
          rotation: 0
        });
      }
    }, {
      key: "resetDirection",
      value: function resetDirection() {
        this.setViewpointRadian({
          direction: 0
        });
      }
    }, {
      key: "resetCirculation",
      value: function resetCirculation() {
        if (this.getMap().northUp) this.resetDirection();else this.resetRotation();
      }
    }, {
      key: "setGPSMarkerAsync",
      value: function setGPSMarkerAsync(position) {
        var _this5 = this;
        var ignoreMove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var map = this.getMap();
        var view = map === null || map === void 0 ? void 0 : map.getView();
        if (!position) {
          return new Promise(function (resolve, _reject) {
            map === null || map === void 0 ? void 0 : map.setGPSPosition(null);
            resolve(true);
          });
        }
        var mercs = this.mercsFromGPSValue(position.lnglat, position.acc);
        return this.mercs2SysCoordsAsync_multiLayer([mercs]).then(function (results) {
          var hide = !results[0];
          var xys = hide ? results[1] : results[0];
          var sub = !hide ? results[1] : null;
          var pos = {
            xy: xys[0][0]
          };
          if (!_this5.insideCheckSysCoord(xys[0][0])) return false;
          var news = xys[0].slice(1);
          pos.rad = news.reduce(function (prev, curr, index) {
            var ret = prev + Math.sqrt(Math.pow(curr[0] - pos.xy[0], 2) + Math.pow(curr[1] - pos.xy[1], 2));
            return index === 3 ? ret / 4.0 : ret;
          }, 0);
          if (!ignoreMove) view === null || view === void 0 ? void 0 : view.setCenter(pos.xy);
          map === null || map === void 0 ? void 0 : map.setGPSPosition(pos, hide ? "hide" : null);
          if (sub) {
            map === null || map === void 0 ? void 0 : map.setGPSPosition({
              xy: sub[0][0]
            }, "sub");
          }
          return true;
        }).catch(function (err) {
          throw err;
        });
      }
    }, {
      key: "setGPSMarker",
      value: function setGPSMarker(position) {
        var ignoreMove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        this.setGPSMarkerAsync(position, ignoreMove).then(function () {});
      }
    }, {
      key: "mercsFromGPSValue",
      value: function mercsFromGPSValue(lnglat, acc) {
        var merc = transform(lnglat, "EPSG:4326", "EPSG:3857");
        var latrad = lnglat[1] * Math.PI / 180;
        var delta = acc / Math.cos(latrad);
        return MERC_CROSSMATRIX.map(function (xy) {
          return [xy[0] * delta + merc[0], xy[1] * delta + merc[1]];
        });
      }
    }, {
      key: "rotateMatrix",
      value: function rotateMatrix(xys, theta) {
        if (theta === undefined) {
          theta = this.getMap().getView().getRotation();
        }
        var result = [];
        for (var i = 0; i < xys.length; i++) {
          var xy = xys[i];
          var x = xy[0] * Math.cos(theta) - xy[1] * Math.sin(theta);
          var y = xy[0] * Math.sin(theta) + xy[1] * Math.cos(theta);
          result.push([x, y]);
        }
        return result;
      }
    }, {
      key: "resolvePois",
      value: function () {
        var _resolvePois = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(pois) {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return normalizeLayers(pois || [], {
                  name: this.officialTitle || this.title,
                  namespace: this.mapID
                });
              case 2:
                this.pois = _context6.sent;
              case 3:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function resolvePois(_x2) {
          return _resolvePois.apply(this, arguments);
        }
        return resolvePois;
      }()
    }, {
      key: "getPoi",
      value: function getPoi(id) {
        var _this6 = this;
        var ret = undefined;
        Object.keys(this.pois).map(function (key) {
          _this6.pois[key].pois.map(function (poi, i) {
            if (poi.id === id) {
              ret = _this6.pois[key].pois[i];
            }
          });
        });
        return ret;
      }
    }, {
      key: "addPoi",
      value: function addPoi(data, clusterId) {
        if (!clusterId) {
          clusterId = "main";
        }
        if (this.pois[clusterId]) {
          data = normalizePoi(data);
          this.pois[clusterId]["pois"].push(data);
          addIdToPoi(this.pois, clusterId, {
            name: this.officialTitle || this.title,
            namespace: this.mapID
          });
          return data.namespaceID;
        }
      }
    }, {
      key: "removePoi",
      value: function removePoi(id) {
        var _this7 = this;
        Object.keys(this.pois).map(function (key) {
          _this7.pois[key].pois.map(function (poi, i) {
            if (poi.id === id) {
              delete _this7.pois[key].pois[i];
            }
          });
        });
      }
    }, {
      key: "clearPoi",
      value: function clearPoi(clusterId) {
        var _this8 = this;
        if (!clusterId) {
          clusterId = "main";
        }
        if (clusterId === "all") {
          Object.keys(this.pois).map(function (key) {
            _this8.pois[key]["pois"] = [];
          });
        } else if (this.pois[clusterId]) {
          this.pois[clusterId]["pois"] = [];
        }
      }
    }, {
      key: "listPoiLayers",
      value: function listPoiLayers() {
        var _this9 = this;
        var hideOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var nonzero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return Object.keys(this.pois).sort(function (a, b) {
          if (a === "main") return -1;else if (b === "main") return 1;else if (a < b) return -1;else if (a > b) return 1;else return 0;
        }).map(function (key) {
          return _this9.pois[key];
        }).filter(function (layer) {
          return nonzero ? hideOnly ? layer.pois.length && layer.hide : layer.pois.length : hideOnly ? layer.hide : true;
        });
      }
    }, {
      key: "getPoiLayer",
      value: function getPoiLayer(id) {
        return this.pois[id];
      }
    }, {
      key: "addPoiLayer",
      value: function addPoiLayer(id, data) {
        if (id === "main") return;
        if (this.pois[id]) return;
        this.pois[id] = normalizeLayer(data || [], id, {
          name: this.officialTitle || this.title,
          namespace: this.mapID
        });
      }
    }, {
      key: "removePoiLayer",
      value: function removePoiLayer(id) {
        if (id === "main") return;
        if (!this.pois[id]) return;
        delete this.pois[id];
      }
    }, {
      key: "merc2SysCoordAsync_ignoreBackground",
      value: function merc2SysCoordAsync_ignoreBackground(merc) {
        var _this10 = this;
        return this.merc2XyAsync_ignoreBackground(merc).then(function (xy) {
          return xy ? _this10.xy2SysCoord(xy) : undefined;
        });
      }
    }, {
      key: "merc2SysCoordAsync",
      value: function merc2SysCoordAsync(merc) {
        var _this11 = this;
        return this.merc2XyAsync(merc).then(function (xy) {
          return xy ? _this11.xy2SysCoord(xy) : xy;
        });
      }
    }, {
      key: "sysCoord2MercAsync",
      value: function sysCoord2MercAsync(sysCoord) {
        var xy = this.sysCoord2Xy(sysCoord);
        return this.xy2MercAsync(xy);
      }
    }, {
      key: "zoom2Radius",
      value: function zoom2Radius(size, zoom) {
        var radius = Math.floor(Math.min(size[0], size[1]) / 4);
        if (zoom === undefined) {
          zoom = this.getMap().getView().getDecimalZoom();
        }
        return radius * MERC_MAX / 128 / Math.pow(2, zoom);
      }
    }, {
      key: "viewpoint2SysCoords",
      value: function viewpoint2SysCoords(viewpoint, size) {
        return this.mercViewpoint2Mercs(viewpoint, size);
      }
    }, {
      key: "mercViewpoint2Mercs",
      value: function mercViewpoint2Mercs(viewpoint, size) {
        var center = viewpoint ? viewpoint[0] : undefined;
        var zoom = viewpoint ? viewpoint[1] : undefined;
        var rotate = viewpoint ? viewpoint[2] : undefined;
        if (center === undefined) {
          center = this.getMap().getView().getCenter();
        }
        if (size === undefined) {
          size = this.getMap().getSize();
        }
        var radius = this.zoom2Radius(size, zoom);
        var crossDelta = this.rotateMatrix(MERC_CROSSMATRIX, rotate);
        var cross = crossDelta.map(function (xy) {
          return [xy[0] * radius + center[0], xy[1] * radius + center[1]];
        });
        return [cross, size];
      }
    }, {
      key: "sysCoords2Viewpoint",
      value: function sysCoords2Viewpoint(sysCoords) {
        return this.mercs2MercViewpoint(sysCoords);
      }
    }, {
      key: "mercs2MercViewpoint",
      value: function mercs2MercViewpoint(mercs) {
        var center = mercs[0][0];
        var size = mercs[1];
        var nesw = mercs[0].slice(1, 5);
        var neswDelta = nesw.map(function (val) {
          return [val[0] - center[0], val[1] - center[1]];
        });
        var normal = [[0.0, 1.0], [1.0, 0.0], [0.0, -1.0], [-1.0, 0.0]];
        var abss = 0;
        var cosx = 0;
        var sinx = 0;
        for (var i = 0; i < 4; i++) {
          var delta = neswDelta[i];
          var norm = normal[i];
          var abs = Math.sqrt(Math.pow(delta[0], 2) + Math.pow(delta[1], 2));
          abss += abs;
          var outer = delta[0] * norm[1] - delta[1] * norm[0];
          var inner = Math.acos((delta[0] * norm[0] + delta[1] * norm[1]) / abs);
          var theta = outer > 0.0 ? -1.0 * inner : inner;
          cosx += Math.cos(theta);
          sinx += Math.sin(theta);
        }
        var scale = abss / 4.0;
        var omega = Math.atan2(sinx, cosx);
        if (!size) size = this.getMap().getSize();
        var radius = Math.floor(Math.min(size[0], size[1]) / 4);
        var zoom = Math.log(radius * MERC_MAX / 128 / scale) / Math.log(2);
        return [center, zoom, omega];
      }
    }, {
      key: "sysCoords2Xys",
      value: function sysCoords2Xys(sysCoords) {
        var _this12 = this;
        return [sysCoords[0].map(function (sysCoord) {
          return _this12.sysCoord2Xy(sysCoord);
        }), sysCoords[1]];
      }
    }, {
      key: "xys2SysCoords",
      value: function xys2SysCoords(xys) {
        var _this13 = this;
        return [xys[0].map(function (xy) {
          return _this13.xy2SysCoord(xy);
        }), xys[1]];
      }
    }, {
      key: "mercs2XysAsync",
      value: function mercs2XysAsync(mercs) {
        var _this14 = this;
        return Promise.all(mercs[0].map(function (merc) {
          return _this14.merc2XyAsync(merc);
        })).then(function (xys) {
          return [xys, mercs[1]];
        });
      }
    }, {
      key: "xys2MercsAsync",
      value: function xys2MercsAsync(xys) {
        var _this15 = this;
        return Promise.all(xys[0].map(function (xy) {
          return _this15.xy2MercAsync(xy);
        })).then(function (mercs) {
          return [mercs, xys[1]];
        });
      }
    }], [{
      key: "isBasemap",
      value: function isBasemap() {
        return this.isBasemap_;
      }
    }, {
      key: "isWmts",
      value: function isWmts() {
        return this.isWmts_;
      }
    }, {
      key: "isMapbox",
      value: function isMapbox() {
        return this.isMapbox_;
      }
    }, {
      key: "createAsync",
      value: function () {
        var _createAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new this(options));
              case 1:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function createAsync(_x3) {
          return _createAsync.apply(this, arguments);
        }
        return createAsync;
      }()
    }]);
    return Mixin;
  }(Base);
  Mixin.isBasemap_ = false;
  Mixin.isWmts_ = true;
  Mixin.isMapbox_ = false;
  return Mixin;
}
export function setCustomFunctionBase(Base) {
  var Mixin = /*#__PURE__*/function (_setCustomFunction) {
    _inherits(Mixin, _setCustomFunction);
    var _super2 = _createSuper(Mixin);
    function Mixin() {
      _classCallCheck(this, Mixin);
      return _super2.apply(this, arguments);
    }
    _createClass(Mixin, [{
      key: "insideCheckXy",
      value: function insideCheckXy(xy) {
        if (!this.envelope) return true;
        return booleanPointInPolygon(xy, this.envelope);
      }
    }, {
      key: "insideCheckSysCoord",
      value: function insideCheckSysCoord(histCoords) {
        return this.insideCheckXy(histCoords);
      }
    }, {
      key: "modulateXyInside",
      value: function modulateXyInside(xy) {
        if (!this.centroid) return xy;
        var expandLine = lineString([xy, this.centroid]);
        var intersect = lineIntersect(this.envelope, expandLine);
        if (intersect.features.length > 0 && intersect.features[0].geometry) {
          return intersect.features[0].geometry.coordinates;
        } else {
          return xy;
        }
      }
    }, {
      key: "modulateSysCoordInside",
      value: function modulateSysCoordInside(histCoords) {
        return this.modulateXyInside(histCoords);
      }
    }, {
      key: "merc2XyAsync",
      value: function merc2XyAsync(merc) {
        return Promise.resolve(merc);
      }
    }, {
      key: "merc2XyAsync_ignoreBackground",
      value: function merc2XyAsync_ignoreBackground(merc) {
        return this.merc2XyAsync(merc);
      }
    }, {
      key: "xy2MercAsync",
      value: function xy2MercAsync(xy) {
        return Promise.resolve(xy);
      }
    }, {
      key: "xy2SysCoord",
      value: function xy2SysCoord(xy) {
        return xy;
      }
    }, {
      key: "sysCoord2Xy",
      value: function sysCoord2Xy(sysCoord) {
        return sysCoord;
      }
    }, {
      key: "viewpoint2MercsAsync",
      value: function viewpoint2MercsAsync(viewpoint, size) {
        var sysCoords = this.viewpoint2SysCoords(viewpoint, size);
        var xys = this.sysCoords2Xys(sysCoords);
        return this.xys2MercsAsync(xys);
      }
    }, {
      key: "mercs2ViewpointAsync",
      value: function mercs2ViewpointAsync(mercs) {
        var _this16 = this;
        return this.mercs2XysAsync(mercs).then(function (xys) {
          var sysCoords = _this16.xys2SysCoords(xys);
          return _this16.sysCoords2Viewpoint(sysCoords);
        });
      }
    }, {
      key: "mercs2SysCoordsAsync_multiLayer",
      value: function mercs2SysCoordsAsync_multiLayer(mercs) {
        var _this17 = this;
        return Promise.all(mercs[0].map(function (merc) {
          return _this17.merc2SysCoordAsync(merc);
        })).then(function (xys) {
          return [[xys, mercs[1]]];
        });
      }
    }, {
      key: "defZoom",
      value: function defZoom() {
        return this.mercZoom;
      }
    }]);
    return Mixin;
  }(setCustomFunction(Base));
  Mixin.isBasemap_ = true;
  Mixin.isWmts_ = true;
  return Mixin;
}
export function setCustomFunctionOverlay(Base) {
  var Mixin = /*#__PURE__*/function (_setCustomFunction2) {
    _inherits(Mixin, _setCustomFunction2);
    var _super3 = _createSuper(Mixin);
    function Mixin() {
      _classCallCheck(this, Mixin);
      return _super3.apply(this, arguments);
    }
    return _createClass(Mixin);
  }(setCustomFunction(Base));
  return Mixin;
}
export function setCustomFunctionMaplat(Base) {
  var Mixin = /*#__PURE__*/function (_setCustomFunction3) {
    _inherits(Mixin, _setCustomFunction3);
    var _super4 = _createSuper(Mixin);
    function Mixin() {
      var _this18;
      _classCallCheck(this, Mixin);
      _this18 = _super4.apply(this, arguments);
      _this18.width = 0;
      _this18.height = 0;
      _this18._maxxy = 0;
      return _this18;
    }
    _createClass(Mixin, [{
      key: "insideCheckXy",
      value: function insideCheckXy(xy) {
        return !(xy[0] < 0 || xy[0] > this.width || xy[1] < 0 || xy[1] > this.height);
      }
    }, {
      key: "insideCheckSysCoord",
      value: function insideCheckSysCoord(sysCoord) {
        return this.insideCheckXy(this.sysCoord2Xy(sysCoord));
      }
    }, {
      key: "modulateXyInside",
      value: function modulateXyInside(xy) {
        var dx = xy[0] / (this.width / 2) - 1;
        var dy = xy[1] / (this.height / 2) - 1;
        var da = Math.max(Math.abs(dx), Math.abs(dy));
        return [(dx / da + 1) * this.width / 2, (dy / da + 1) * this.height / 2];
      }
    }, {
      key: "modulateSysCoordInside",
      value: function modulateSysCoordInside(histCoords) {
        var xy = this.sysCoord2Xy(histCoords);
        var ret = this.modulateXyInside(xy);
        return this.xy2SysCoord(ret);
      }
    }, {
      key: "xy2SysCoord",
      value: function xy2SysCoord(xy) {
        var sysCoordX = xy[0] * (2 * MERC_MAX) / this._maxxy - MERC_MAX;
        var sysCoordY = -1 * (xy[1] * (2 * MERC_MAX) / this._maxxy - MERC_MAX);
        return [sysCoordX, sysCoordY];
      }
    }, {
      key: "sysCoord2Xy",
      value: function sysCoord2Xy(sysCoord) {
        var x = (sysCoord[0] + MERC_MAX) * this._maxxy / (2 * MERC_MAX);
        var y = (-sysCoord[1] + MERC_MAX) * this._maxxy / (2 * MERC_MAX);
        return [x, y];
      }
    }, {
      key: "defZoom",
      value: function defZoom(screenSize) {
        var screenWidth = screenSize[0];
        var screenHeight = screenSize[1];
        var delZoomOfWidth = Math.log2((screenWidth - 10) / this.width);
        var delZoomOfHeight = Math.log2((screenHeight - 10) / this.height);
        var maxZoom = this.maxZoom;
        var delZoom;
        if (delZoomOfHeight > delZoomOfWidth) {
          delZoom = delZoomOfHeight;
        } else {
          delZoom = delZoomOfWidth;
        }
        return maxZoom + delZoom;
      }
    }]);
    return Mixin;
  }(setCustomFunction(Base));
  Mixin.isBasemap_ = false;
  Mixin.isWmts_ = false;
  return Mixin;
}
export var META_KEYS = ["title", "officialTitle", "author", "createdAt", "era", "contributor", "mapper", "license", "dataLicense", "attr", "dataAttr", "reference", "description"];
var META_KEYS_OPTION = ["title", "official_title", "author", "created_at", "era", "contributor", "mapper", "license", "data_license", "attr", "data_attr", "reference", "description"];
export function addCommonOptions(options) {
  options = normalizeArg(options);
  if (!options.imageExtension) options.imageExtension = "jpg";
  if (options.mapID && !options.url && !options.urls) {
    options.url = options.tms ? "tiles/".concat(options.mapID, "/{z}/{x}/{-y}.").concat(options.imageExtension) : "tiles/".concat(options.mapID, "/{z}/{x}/{y}.").concat(options.imageExtension);
  }
  return options;
}
export function setupTileLoadFunction(target) {
  var self = target;
  target.setTileLoadFunction(function () {
    var numLoadingTiles = 0;
    var tileLoadFn = self.getTileLoadFunction();
    var tImageLoader = function tImageLoader(_tileCoord, src, tCanv, sx, sy, sw, sh) {
      return new Promise(function (resolve, _reject) {
        var loader = function loader(src) {
          var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
          if (numLoadingTiles === 0) {}
          ++numLoadingTiles;
          var tImage = document.createElement("img");
          tImage.crossOrigin = "Anonymous";
          tImage.onload = tImage.onerror = function () {
            if (tImage.width && tImage.height) {
              var ctx = tCanv.getContext("2d");
              var dx = sx === 0 ? 256 - sw : 0;
              var dy = sy === 0 ? 256 - sh : 0;
              sw = sx + sw > tImage.width ? tImage.width - sx : sw;
              sh = sy + sh > tImage.height ? tImage.height - sy : sh;
              ctx.drawImage(tImage, sx, sy, sw, sh, dx, dy, sw, sh);
              resolve(undefined);
            } else {
              if (fallback) {
                loader(fallback);
              } else {
                resolve("tileLoadError");
              }
            }
            --numLoadingTiles;
            if (numLoadingTiles === 0) {}
          };
          tImage.src = src;
        };
        loader(src);
      });
    };
    return function (tile, _src) {
      var zoom = tile.tileCoord[0];
      var tileX = tile.tileCoord[1];
      var tileY = tile.tileCoord[2];
      var pixelXShift = Math.round((self.mercatorXShift || 0) * 128 * Math.pow(2, zoom) / MERC_MAX);
      var pixelYShift = Math.round((self.mercatorYShift || 0) * -128 * Math.pow(2, zoom) / MERC_MAX);
      while (pixelXShift < 0 || pixelXShift >= 256) {
        if (pixelXShift < 0) {
          pixelXShift = pixelXShift + 256;
          tileX++;
        } else {
          pixelXShift = pixelXShift - 256;
          tileX--;
        }
      }
      while (pixelYShift < 0 || pixelYShift >= 256) {
        if (pixelYShift < 0) {
          pixelYShift = pixelYShift + 256;
          tileY++;
        } else {
          pixelYShift = pixelYShift - 256;
          tileY--;
        }
      }
      var tmp = document.createElement("div");
      tmp.innerHTML = canvBase;
      var tCanv = tmp.childNodes[0];
      var promises = [[[zoom, tileX, tileY], 0, 0, 256 - pixelXShift, 256 - pixelYShift]];
      if (pixelXShift !== 0) {
        promises.push([[zoom, tileX - 1, tileY], 256 - pixelXShift, 0, pixelXShift, 256 - pixelYShift]);
      }
      if (pixelYShift !== 0) {
        promises.push([[zoom, tileX, tileY - 1], 0, 256 - pixelYShift, 256 - pixelXShift, pixelYShift]);
        if (pixelXShift !== 0) {
          promises.push([[zoom, tileX - 1, tileY - 1], 256 - pixelXShift, 256 - pixelYShift, pixelXShift, pixelYShift]);
        }
      }
      Promise.all(promises.map(function (item) {
        var url = self.tileUrlFunction(item[0], self.tilePixelRatio_, self.projection_);
        return tImageLoader(item[0], url, tCanv, item[1], item[2], item[3], item[4]);
      })).then(function (rets) {
        var err = rets.reduce(function (prev, ret) {
          return prev && ret;
        }, true);
        if (err) {
          tile.handleImageError_();
        } else {
          var dataUrl = tCanv.toDataURL();
          var image = tile.getImage();
          image.crossOrigin = null;
          tileLoadFn(tile, dataUrl);
        }
      }).catch(function (_err) {
        tile.handleImageError_();
      });
    };
  }());
}